import Input from './Input';
import Group from './Group';

Input.Group = Group;
export default Input;



/** WEBPACK FOOTER **
 ** ./components/input/index.jsx
 **/